import AddIcon from 'assets/icons/add.svg';

import { Dialog } from 'primereact/dialog';
import classes from './ndcViewModal.module.scss';

import { NDCEditFormDropDownResponseInterface } from 'Interfaces/FactsInterfaces/drugInterfaces';
import { observer } from 'mobx-react';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Divider } from 'primereact/divider';
import { Dropdown } from 'primereact/dropdown';
import {
  getFirstDayOfMonth,
  getLastDayOfMonth,
  getNextMonthFirstDay,
  getOneBiggerDate,
  getOneSmallerDate,
  getTomorowsDate,
  DateConversionUtility,
} from 'utils/dateUtilities';
import NdcHistoryTable from '../ndcHistoryTable/NdcHistoryTable';
import { useNdcStrategyAddModal } from './useNdcViewModal';

const NdcViewModal = ({
  visibility,
  toggleVisibility,
}: {
  visibility: boolean;
  toggleVisibility: () => void;
}) => {
  const tomorrowsDate = new Date();
  tomorrowsDate.setDate(tomorrowsDate.getDate() + 1);

  const {
    ndcFormDropDownData,
    isAnyStrategySelected,
    selectedNdcRowData,
    isHistoryVisible,
    initialNdcStrategyIndividualEditData,
    toggleHistoryVisibility,
    convertNdcFormDataToAllOptions,
    maxDateFromGivenAndTodays,
    errorDetails,
    ndcStrategyIndividualEditData,
    formFieldsArrayConverter,
    selectedOption,
    toggleAddModalVisibility,
    setAddModalHeading,
  } = useNdcStrategyAddModal();
  return (
    <Dialog
      blockScroll
      resizable={false}
      draggable={false}
      header={`View NDC - ${selectedNdcRowData?.NDC11} `}
      headerClassName={classes.modalHeader}
      visible={visibility}
      style={{ width: '55vw' }}
      onHide={() => {
        if (!visibility) return;
        toggleVisibility();
      }}
    >
      <div className={classes.modalContainer}>
        <Divider className={classes.devider} />
        <div className={classes.updateTooltip}>
          <span className={classes.tooltipMessage}>
            * Fields for which start date is in future, will only be visible in future
          </span>
          <div></div>
        </div>

        {isAnyStrategySelected() ? (
          <>
            {ndcStrategyIndividualEditData && initialNdcStrategyIndividualEditData && (
              <>
                {formFieldsArrayConverter().map((fieldValues, index) => {
                  return (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
                      {fieldValues.selected && fieldValues.keyName !== 'PPSSC' ? (
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '0.5rem',
                            width: '100%',
                          }}
                        >
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                            }}
                          >
                            <span>
                              {fieldValues.keyName === 'PPS'
                                ? 'PPS & PPS Reason'
                                : fieldValues.keyName === 'DPStrategy'
                                  ? 'Demand Planning'
                                  : 'Financial Segmentation'}
                            </span>
                            <span></span>
                          </div>
                          <div style={{ display: 'flex', gap: '1rem', width: '100%' }}>
                            <div style={{ width: '50%' }}>
                              <div
                                style={{ display: 'flex', width: '100%', gap: '0.5rem' }}
                                className={classes.valuesContainer}
                              >
                                <Dropdown
                                  style={{ width: '100%' }}
                                  key={index}
                                  value={selectedOption(fieldValues.keyName, fieldValues.value)}
                                  options={
                                    convertNdcFormDataToAllOptions(
                                      ndcFormDropDownData as NDCEditFormDropDownResponseInterface
                                    )[fieldValues.keyName]
                                  }
                                  optionLabel="name"
                                  disabled={true}
                                  placeholder="Select strategy"
                                />
                                <Button
                                  outlined
                                  className={classes.historicalButton}
                                  style={{ border: '1px solid grey' }}
                                  // label="Add"
                                  disabled={true}
                                  onClick={() => {
                                    setAddModalHeading(fieldValues.keyName);
                                    toggleAddModalVisibility();
                                  }}
                                >
                                  <img src={AddIcon} alt="add icon" />
                                </Button>
                              </div>
                            </div>
                            <div style={{ width: '50%' }}>
                              {fieldValues.keyName === 'PPS' && (
                                <div
                                  style={{ display: 'flex', width: '100%', gap: '0.5rem' }}
                                  className={classes.valuesContainer}
                                >
                                  <Dropdown
                                    style={{ width: '100%' }}
                                    key={index}
                                    value={selectedOption(
                                      'PPSSC',
                                      ndcStrategyIndividualEditData.PPSSC.value
                                    )}
                                    options={
                                      convertNdcFormDataToAllOptions(
                                        ndcFormDropDownData as NDCEditFormDropDownResponseInterface
                                      ).PPSSC
                                    }
                                    optionLabel="name"
                                    disabled={true}
                                    placeholder="Select strategy"
                                  />
                                  <Button
                                    outlined
                                    style={{ border: '1px solid grey' }}
                                    disabled={true}
                                    className={classes.historicalButton}
                                    // label="Add"
                                    onClick={() => {
                                      setAddModalHeading('PPSSC');
                                      toggleAddModalVisibility();
                                    }}
                                  >
                                    <img src={AddIcon} alt="add icon" />
                                  </Button>
                                </div>
                              )}
                            </div>
                          </div>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                            <div style={{ width: '100%' }}>
                              {!fieldValues.monthYearDates ? (
                                <Calendar
                                  style={{ width: '100%' }}
                                  className={classes.dateInput}
                                  minDate={new Date()}
                                  maxDate={
                                    ndcStrategyIndividualEditData[fieldValues.keyName].endDate ===
                                    initialNdcStrategyIndividualEditData[fieldValues.keyName]
                                      .endDate
                                      ? undefined
                                      : getOneSmallerDate(
                                          new Date(
                                            ndcStrategyIndividualEditData[
                                              fieldValues.keyName
                                            ].endDate
                                          )
                                        )
                                  }
                                  value={DateConversionUtility.convertDBDateToLocal(
                                    ndcStrategyIndividualEditData[fieldValues.keyName].startDate
                                  )}
                                  disabled={true}
                                  showIcon
                                />
                              ) : (
                                <Calendar
                                  style={{ width: '100%' }}
                                  view="month"
                                  dateFormat="mm/yy"
                                  className={classes.dateInput}
                                  minDate={getNextMonthFirstDay(new Date().toDateString())}
                                  maxDate={
                                    ndcStrategyIndividualEditData[fieldValues.keyName].endDate ===
                                    initialNdcStrategyIndividualEditData[fieldValues.keyName]
                                      .endDate
                                      ? undefined
                                      : getFirstDayOfMonth(
                                          new Date(
                                            ndcStrategyIndividualEditData[
                                              fieldValues.keyName
                                            ].endDate
                                          ).toDateString()
                                        )
                                  }
                                  value={DateConversionUtility.convertDBDateToLocal(
                                    ndcStrategyIndividualEditData[fieldValues.keyName].startDate
                                  )}
                                  disabled={true}
                                  showIcon
                                />
                              )}
                            </div>
                            <div style={{ width: '100%' }}>
                              {!fieldValues.monthYearDates ? (
                                <Calendar
                                  style={{ width: '100%' }}
                                  className={classes.dateInput}
                                  minDate={
                                    initialNdcStrategyIndividualEditData[fieldValues.keyName]
                                      .endDate
                                      ? getOneBiggerDate(
                                          maxDateFromGivenAndTodays(
                                            new Date(
                                              initialNdcStrategyIndividualEditData[
                                                fieldValues.keyName
                                              ].endDate
                                            )
                                          )
                                        )
                                      : getTomorowsDate()
                                  }
                                  value={DateConversionUtility.convertDBDateToLocal(
                                    ndcStrategyIndividualEditData[fieldValues.keyName].endDate
                                  )}
                                  disabled={true}
                                  showIcon
                                />
                              ) : (
                                <Calendar
                                  style={{ width: '100%' }}
                                  view="month"
                                  dateFormat="mm/yy"
                                  className={classes.dateInput}
                                  minDate={
                                    initialNdcStrategyIndividualEditData[fieldValues.keyName]
                                      .endDate
                                      ? getNextMonthFirstDay(
                                          initialNdcStrategyIndividualEditData[fieldValues.keyName]
                                            .endDate
                                        )
                                      : getLastDayOfMonth(new Date().toDateString())
                                  }
                                  value={DateConversionUtility.convertDBDateToLocal(
                                    ndcStrategyIndividualEditData[fieldValues.keyName].endDate
                                  )}
                                  disabled={true}
                                  showIcon
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  );
                })}
              </>
            )}
          </>
        ) : (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '3rem',
              width: '100%',
              border: '1px solid grey',
              borderRadius: '0.3rem',
            }}
          >
            <span>Please select some strategy to edit</span>
          </div>
        )}

        {errorDetails.isError && (
          <div className={classes.errorDetails}>{`* ${errorDetails.errorDetails}`}</div>
        )}
        <div className={classes.updateButtonWrapper}>
          <Button
            onClick={toggleHistoryVisibility}
            outlined
            className={classes.historicalButton}
            label="Historical/Future values"
          />
          <div></div>
        </div>

        {isHistoryVisible && <NdcHistoryTable />}
      </div>
    </Dialog>
  );
};

export default observer(NdcViewModal);
